import React, { useEffect, useRef, useState } from "react";
import api from "APP_ROOT/api";
import { Col, Row } from "react-bootstrap";
import DetailStat from "MODULES/shared/components/StatsTooltip/DetailStat";
import { dollar } from "MODULES/shared/components/StatsTooltip/format";
import useDebounce from "../../../../hooks/useDebounce";

export default function InventoryStats({ alwaysDisplayBuyerStats, filters }) {
  const [stats, setStats] = useState({});
  const latestRequestRef = useRef(0);
  const debouncedSearchArgs = useDebounce(
    300,
    Object.entries(filters)
      .flatMap(pair => pair)
      .join("-")
  );

  useEffect(() => {
    const currentRequest = latestRequestRef.current + 1;
    latestRequestRef.current = currentRequest;
    api.inventories.stats(filters).then(res => {
      if (res.data) setStats(res.data);
      return function cleanup() {};
    });
  }, debouncedSearchArgs);

  const total = [
    stats.total_cost_0_to_6_months_dollars,
    stats.total_cost_6_to_12_months_dollars,
    stats.total_cost_12_to_18_months_dollars,
    stats.total_cost_18_to_INF_months_dollars
  ].reduce((agg, v) => agg + Number(v), 0);

  const totalBuyer = [
    stats.buyer_credit_0_to_6_months_dollars,
    stats.buyer_credit_6_to_12_months_dollars,
    stats.buyer_credit_12_to_18_months_dollars,
    stats.buyer_credit_18_to_INF_months_dollars
  ].reduce((agg, v) => agg + Number(v), 0);

  return [
    <Row>
      <DetailStat label="Total" value={dollar(total)} />
      <DetailStat
        label="Total Unapplied Lot Cost"
        value={dollar(stats.total_unapplied_lot_cost)}
      />
      <DetailStat
        label="<6 mos"
        value={dollar(stats.total_cost_0_to_6_months_dollars)}
      />
      <DetailStat
        label="6 to 12 mos"
        value={dollar(stats.total_cost_6_to_12_months_dollars)}
      />
      <DetailStat
        label="12 to 18 mos"
        value={dollar(stats.total_cost_12_to_18_months_dollars)}
      />
      <DetailStat
        label=">18 mos"
        value={dollar(stats.total_cost_18_to_INF_months_dollars)}
      />
      <Col md={1} sm={1}>
        &nbsp;
      </Col>
    </Row>,
    (filters.buyer_id || alwaysDisplayBuyerStats) && (
      <Row>
        <Col md={1} sm={1}>
          &nbsp;
        </Col>
        <DetailStat label="Total" value={dollar(totalBuyer)} />
        <DetailStat
          label="<6 mos Buyer Credit"
          value={dollar(stats.buyer_credit_0_to_6_months_dollars)}
        />
        <DetailStat
          label="6 to 12 mos Buyer Credit"
          value={dollar(stats.buyer_credit_6_to_12_months_dollars)}
        />
        <DetailStat
          label="12 to 18 mos Buyer Credit"
          value={dollar(stats.buyer_credit_12_to_18_months_dollars)}
        />
        <DetailStat
          label=">18 mos Buyer Credit"
          value={dollar(stats.buyer_credit_18_to_INF_months_dollars)}
        />
        <Col md={1} sm={1}>
          &nbsp;
        </Col>
      </Row>
    )
  ];
}



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Search/InventoryStats.jsx